module.exports = __webpack_public_path__ + "static/media/Header_992_us.07505b89.png";